// Subtheme Widget Scripts
import customTicketButton from '../widgets/customTicketButton.js';
import slideshow from '../widgets/slideshow.js';
import cardWidget from '../widgets/cardWidget.js';
import fairCountdown from '../widgets/fairCountdown.js';
import videoWidget from '../widgets/videoWidget.js';
import seoWidget from '../widgets/seoWidget.js';
import scrollerSponsorsDouble from '../widgets/scrollerSponsorsDouble.js';
import { isPage } from '../helpers.js';

export default function initFairWidgets() {
  customTicketButton();
  if (isPage('douglas-county-fair-home')) {
    slideshow('fairSlideshow', fairSlideshowOpts);
    fairCountdown();
    cardWidget('fairCardWidget', fairCardWidgetOpts, 5);
    seoWidget('fairSeoWidget', fairSeoWidgetOpts);
    scrollerSponsorsDouble('fair-scroller-sponsors', fairScrollerSponsorsOpts, 6);
    $(globalThis).load(function () {
      videoWidget('videoWidget', fairVideoWidgetOpts);
    });
  }
}
